<template>
  <v-container fluid>
    <TopHeader>
      <template v-slot:title>
        <span class="text-h5">
          Manage /
          <span class="breadcrumb-link" @click="returnToBrands">Brands</span>
          /
          <v-progress-circular
            class="ml-1"
            v-if="loading.brand"
            indeterminate
            color="primary"
            :size="22"
          ></v-progress-circular>
          <span class="primary--text" v-else-if="brand">{{ brand.name }}</span>
          <span class="primary--text" v-else>{{ $route.params.brand }}</span>
        </span>
      </template>
      <template v-slot:right>
        <span
          class="subtitle-1 grey--text font-weight-light d-flex"
          style="align-items: flex-end"
        >
          <v-btn
            @click="submitProposal(false)"
            outlined
            color="primary"
            :disabled="(hasChanged && !isEditingProposal) || loading.proposal"
            :loading="loading.proposal"
          >
            <v-icon left>mdi-check</v-icon> submit update
          </v-btn>
        </span>
      </template>
    </TopHeader>
    <PlaceholderWrapper
      class="mt-10"
      :is-empty="brand === null"
      :is-loading="loading.proposal || loading.brand"
      empty-message="We didn't find the brand you requested"
    >
      <template v-slot:content>
        <div>
          <ValidationControls
            @validate="handleValidate"
            @reject="handleRejection"
            :proposal="proposal"
            v-if="hasPendingProposal && $store.getters.isUserAdmin"
          />

          <v-row class="mt-5">
            <v-col cols="6">
              <div class="text-center primary--text text-h6">Current</div>
              <div class="mt-6 pa-6">
                <Brand
                  @onLangTabChange="t => (langTab = t)"
                  :lang-tab-index="langTab"
                  v-model="brand"
                  readOnly
                />
              </div>
            </v-col>
            <v-col cols="6">
              <ProposalStaging
                @edit="v => (editMode = v)"
                :cancelEditCounter="cancelEditCounter"
                @cancel="handleCancel"
                :loading="loading.proposal"
                :last-proposal="proposal"
              >
                <template v-slot>
                  <div class="text-center text-h6 accent--text">Proposal</div>
                  <div class="mt-6 pa-6">
                    <Brand
                      @addLocale="handleAddLocale"
                      @onLangTabChange="t => (langTab = t)"
                      :lang-tab-index="langTab"
                      :isDifferentImage="hasDifferentImage"
                      :differencesLocales="differencesLocales"
                      v-model="brandProposal"
                    />
                  </div>
                </template>
              </ProposalStaging>
            </v-col>
          </v-row>
        </div>
      </template>
    </PlaceholderWrapper>
  </v-container>
</template>

<script>
import PlaceholderWrapper from "@/components/base/PlaceholderWrapper"
import * as CONSTS from "@/data"
import { Brand, ValidationControls } from "@/components"
import { BrandService } from "@/services"
import TopHeader from "@/components/base/TopHeader.vue"
import ProposalStaging from "@/components/perfumist/ProposalStaging.vue"
import _ from "lodash"
export default {
  components: {
    ProposalStaging,
    TopHeader,
    Brand,
    PlaceholderWrapper,
    ValidationControls
  },
  data() {
    return {
      langTab: null,
      loading: {
        proposal: true,
        brand: true
      },
      proposal: null,
      brand: null,
      brandProposal: null,
      brandProposalReference: null,
      cancelEditCounter: 0,
      editMode: true,
      hasDifferentImage: false,
      differencesLocales: {
        locales: {
          en: {
            name: false
          }
        }
      }
    }
  },
  created() {
    this.getBrand()
  },
  computed: {
    id() {
      return this.$route.params.brand
    },
    hasPendingProposal() {
      return this.proposal.pending_request !== null
    },
    isEditingProposal() {
      if (
        this.brandProposalReference == null ||
        this.brandProposal == null ||
        this.proposal == null
      )
        return false
      return !_.isEqual(this.brandProposal, this.brandProposalReference)
    },
    hasChanged() {
      if (this.brand === null) return false

      return !_.isEqual(
        _.pick(this.brandProposal, ["data"]),
        _.pick(this.brand, ["data"])
      )
    }
  },
  watch: {
    "$store.state.globalBrand"(newValue, oldValue) {
      if (newValue) {
        if (this.id) this.$router.push({ name: "Brand" })
        this.getBrand()
      }
    }
  },
  methods: {
    returnToBrands() {
      if (this.id) this.$router.push({ name: "Brand" })
      if (this.$store.state.globalBrand)
        this.$store.commit("setGlobalBrand", { id: null, name: "All brands" })
    },
    handleAddLocale(locale) {
      this.brand?.data?.locales?.push(locale)
    },
    handleCancel() {
      if (confirm("Are you sure you want to cancel this request ?")) {
        BrandService.cancel(this, this.brand.id).then(r => {
          this.getBrand()
          this.$store.commit("success", "Proposal request cancelled !")
        })
      }
    },
    cancelEditProposal() {
      this.brandProposal = _.cloneDeep(this.brandProposalReference)
      this.cancelEditCounter = this.cancelEditCounter + 1
    },
    submitProposal() {
      if (
        confirm(
          `Are you sure you want to send this edit proposal? ${
            this.$store.getters.isUserAdmin
              ? "(As an admin, this request is approved automatically)"
              : ""
          }`
        )
      ) {
        this.loading.proposal = true
        // let approveState = {
        //   approved: this.$store.getters.isUserAdmin,
        //   verified_by_id: this.$store.state.user?.id || null,
        //   verified_at: this.$store.getters.isUserAdmin ? new Date() : null,
        //   data_old: this.$store.getters.isUserAdmin ? this.brand.data : null,
        //   data_approved: this.$store.getters.isUserAdmin
        //     ? this.brandProposal.data
        //     : null
        // }
        BrandService.create(
          this,
          {
            // brand_id: this.brand.id,
            data: this.brandProposal.data,
            data_approved: this.brandProposal.data,
            status: CONSTS.PROPOSAL_STATUS.EDIT_REQUEST
            // created_at: new Date(),
            // updated_at: new Date(),
            // ...approveState
          },
          this.brand.id
        )
          .then(r => {
            this.getBrand()
          })
          .finally(() => {
            this.loading.proposal = false
          })
      }
    },
    getBrand() {
      this.loading.brand = true
      this.loading.proposal = true
      this.hasDifferentImage = false
      BrandService.get(this, this.id || this.$store.state.globalBrand?.id)
        .then(result => {
          const brand = result

          const proposal = {}

          this.brand = brand
          if (brand.pending_request) {
            this.proposal = brand.pending_request
            // Patch brand proposal to add Image on Root
            this.proposal["data"] = this.proposal["data_approved"]
            this.proposal["status"] = this.brand["status"]
            this.proposal["pending_request"] = this.brand["pending_request"]
          } else {
            this.proposal = brand
          }

          this.brandProposal = _.cloneDeep(this.proposal)
          this.brandProposalReference = _.cloneDeep(this.proposal)

          if (brand.pending_request && this.brandProposal.data_approved) {
            if (
              !_.isEqual(
                this.brand.data.image,
                this.brandProposal.data_approved.image
              )
            ) {
              this.hasDifferentImage = true
            }
          }

          let codeLocalesdifferences = this.brand.data.locales.filter(x =>
            this.brandProposal.data_approved.locales.every(
              x2 => x2.code !== x.code
            )
          )

          codeLocalesdifferences.forEach(element => {
            this.brandProposal.data_approved.locales.push(element)
          })

          if (this.brandProposal.data_approved.locales) {
            this.getLocalesDifferences(
              this.brandProposal.data_approved.locales,
              this.brand.data.locales
            )
          }
        })
        .finally(() => {
          this.loading.brand = false
          this.loading.proposal = false
        })
    },
    getLocalesDifferences(obj1, obj2) {
      obj1.forEach(a => {
        obj2.forEach(b => {
          if (a.code == b.code) {
            if (a.data.name) {
              this.differencesLocales.locales[a.code] = {
                name: !_.isEqual(a.data.name, b.data.name)
              }
            }
          }
        })
      })
    },
    handleValidate() {
      if (this.hasPendingProposal)
        BrandService.editRequest
          .approve(this, this.brand.id, this.proposal)
          .then(r => {
            this.getBrand()
            this.$store.commit("success", "Request validated")
          })
    },
    handleRejection(msg) {
      if (this.hasPendingProposal)
        BrandService.editRequest.reject(this, this.brand.id, msg).then(r => {
          this.getBrand()
          this.$store.commit("success", "Request rejected")
        })
    }
  }
}
</script>

<style lang="scss" scoped></style>
